import { Anchor } from "@svea/design-system-components-react";
import { SvgIcon, useText } from "@sveabank/cc-common";
import { Link } from "react-router";

const LoginHeader = () => {
	const [t, texts] = useText();

	return (
		<header className="border-foreground-divider bg-background-primary font-default mx-auto flex max-h-[80px] min-h-[80px] w-full max-w-[1140px] items-center justify-between border-b border-solid p-6 px-0">
			<SvgIcon imageSrc="LOGO" height={32} className="text-interactive-secondary" />
			<div>
				<Anchor as={Link} to={t(texts.header.linkUrl)} iconEnd="chevronRight">
					{t(texts.header.linkText)}
				</Anchor>
			</div>
		</header>
	);
};

export default LoginHeader;
